export type ApolloOperationKind = 'data-refresh' | 'fiscalization' | 'kkt-health' | 'tenant-transition';

export interface ApolloOperationGate {
  runExclusive: <T>(kind: ApolloOperationKind, operation: () => Promise<T>) => Promise<T>;
  isRunning: (kind?: ApolloOperationKind) => boolean;
}

export const createApolloOperationGate = (): ApolloOperationGate => {
  let queueTail: Promise<void> = Promise.resolve();
  let activeKind: ApolloOperationKind | null = null;

  const runExclusive = async <T>(kind: ApolloOperationKind, operation: () => Promise<T>): Promise<T> => {
    const previousTurn = queueTail;
    let releaseTurn: () => void = () => undefined;
    queueTail = new Promise<void>((resolve) => {
      releaseTurn = resolve;
    });

    await previousTurn;
    activeKind = kind;

    try {
      return await operation();
    } finally {
      activeKind = null;
      releaseTurn();
    }
  };

  return {
    runExclusive,
    isRunning: (kind) => activeKind !== null && (kind === undefined || activeKind === kind),
  };
};

export const apolloOperationGate = createApolloOperationGate();
